import {
  useQueryParams,
  withDefault,
  createEnumParam,
  SetQuery
} from 'use-query-params';
import { QueryParamConfigMap } from 'serialize-query-params';

export const CONSUMER_PROFILE_TABS = {
  info: [],
  appointments: [],
  account: [
    'saved_cards',
    'receipts',
    'used_credits',
    'remaining_credits',
    'expired_credits',
    'account_balance'
  ],
  membership: ['client_membership', 'auto_pay_history'],
  alerts_and_notes: [],
  wellness_plan: [],
  waivers: [],
  documents: ['pow', 'uploaded', 'mind_body'],
  advancedmd: []
} as const;

export type TabKey = keyof typeof CONSUMER_PROFILE_TABS;

type SubTab =
  (typeof CONSUMER_PROFILE_TABS)[keyof typeof CONSUMER_PROFILE_TABS][number];

const ALL_SUBTABS = Object.values(CONSUMER_PROFILE_TABS).flat() as SubTab[];

const TAB_PARAM = createEnumParam(
  Object.keys(CONSUMER_PROFILE_TABS) as TabKey[]
);

export type CustomerProfileQueryParams = {
  tab: TabKey;
  subTab?: SubTab | null;
};

export function useCustomerProfileQueryParams(): [
  CustomerProfileQueryParams,
  SetQuery<QueryParamConfigMap>
] {
  const [query, setQuery] = useQueryParams(
    {
      tab: withDefault(TAB_PARAM, 'info'),
      subTab: createEnumParam(ALL_SUBTABS)
    },
    { removeDefaultsFromUrl: true }
  );

  if (
    query.subTab &&
    !(CONSUMER_PROFILE_TABS[query.tab] as readonly SubTab[]).includes(
      query.subTab
    )
  ) {
    setQuery({ subTab: undefined }, 'pushIn');
  }

  return [query, setQuery];
}
